<div class='top'>
    <!-- <ion-spinner (click)='playRecording()' [hidden]='!audioProvider.isWaiting' class='waiting' name='lines'></ion-spinner> -->
    <!-- <i (click)='playRecording()' [hidden]='audioProvider.isWaiting' [ngClass]='recordingClass()'></i> -->
    <h1 (click)='playRecording()'><i class="mt-alert song-not-available" *ngIf="!isPlayable" title="Song may be unavailable"></i>{{song.name}}</h1>
    <div [hidden]="isCustomSong" class="audioPlayer">
      <div (click)='playRecording()' [ngClass]="(!player?.playing) ? 'mt-play-selected' : 'mt-pause-selected'"></div>
      <audio id="plyrID" crossorigin playsinline>
        <source [src]="song.url" type="audio/mp3" />
        <source [src]="song.url" type="audio/ogg" />
      </audio>
    </div>
    <div *ngIf="isCustomSong" (click)='openUrl(song.url)' class="customSong">
      <div class="mt-play-selected"></div>
      <div class="urls">{{song.url}}</div>
    </div>
</div>

<div class='bottom'>
  <div class='contents'>
    <div class='section horizontal'>
      <div class='left'>
        <h2>Tonality (SP)</h2>
        <p>{{song.formattedTonality}}</p>    
      </div>
      <div class='right'>
        <h2>Meter</h2>
        <p>{{song.meter}}</p>    
      </div>
    </div>
    <div class='section horizontal' [hidden]='!song.isSwow && !song.time'>
      <div class='left' [hidden]='!song.time'>
        <h2>Track Length</h2>
        <p>{{song.time}}</p>    
      </div>
      <div class='right'>
        <h2></h2>
        <p class='swow' [hidden]='!song.isSwow'>* SWOW</p>    
      </div>
    </div>
   
    <ng-container *ngIf='song.suggestedActivity || song.otherInfo || song.tsbUrl'>
      <div class='separator'></div>

      <div class='section' *ngIf='song.suggestedActivity'>
        <h2>Suggested Basic Activity</h2>
        <p>{{song.suggestedActivity || 'None'}}</p>
      </div>
  
      <div class='section' *ngIf='song.otherInfo'>
        <h2>Other Ideas</h2>
        <p>{{song.otherInfo}}</p>
      </div>    

      <div class='section' *ngIf='song.tsbUrl'>
        <h2>Teacher Songbook Page</h2>
        <a href='{{song.tsbUrl}}' target='_blank'>Song Info, Activities & Notation (PDF)</a>
      </div>
    </ng-container>

    <ng-container *ngIf='collection.name'>
      <div class='separator'></div>

      <div class='section horizontal'>
        <div class='left'>
            <h2>Collection</h2>
            <p>{{collection.name}}</p>    
        </div>
        <div class='right'>
            <h2>Used</h2>
            <p>{{course.songUsedCount(song)}} times</p>    
        </div>
      </div>
    </ng-container>

    <ng-container *ngIf='false'>
      <div class='separator'></div>
  
      <div class='section'>
        <h2>TP</h2>
        <button>TBD</button>
      </div>
  
      <div class='section'>
        <h2>RP</h2>
        <button>TBD</button>
      </div>
    </ng-container>

    <ng-container *ngIf='availableVideos(song).length > 0'>
      <div class='separator'></div>
  
      <div class='section vertical'>
        <h2>Available Videos</h2>
        <a *ngFor='let video of availableVideos(song)' href='{{video.url}}' target='_blank'>{{video.name}}</a>
      </div>
    </ng-container>

    <ng-container *ngIf='articles(song).length > 0'>
      <div class='separator'></div>
  
      <div class='section vertical'>
        <h2>Articles</h2>
        <a *ngFor='let article of articles(song)' href='/blog/{{article.slug}}'>{{article.title}}</a>
      </div>
    </ng-container>

    <ng-container *ngIf='additionalResources().length > 0'>
      <div class='separator'></div>
  
      <div class='section vertical'>
        <h2>Additional Resources</h2>
        <div *ngIf="additionResourceParenthesisData().length > 0">
          <div *ngFor='let tool of additionResourceParenthesisData()' class="additional-resource">
            <a href='{{tool.url}}' target='_blank'>{{tool.name}}</a>
        </div>
        </div>
        <div class="margin-top" *ngIf="additionResourceTSBTags().length > 0">
          <div *ngFor='let tool of additionResourceTSBTags()' class="additional-resource">
            <a href='{{tool.url}}' target='_blank'>{{tool.name}}</a>
         </div>
        </div>
        <div class="margin-top" *ngIf="additionResourceOtherData().length > 0">
          <div *ngFor='let tool of additionResourceOtherData()' class="additional-resource">
            <a  href='{{tool.url}}' target='_blank'>{{tool.name}}</a>
          </div>
        </div>
        <!-- <a *ngFor='let tool of additionalResources(song)' href='{{tool.url}}' target='_blank'>{{tool.name}}</a>
        <a *ngFor='let tool of additionalResources(song)' href='{{tool.url}}' target='_blank'>{{tool.name}}</a> -->
      </div>
    </ng-container>

    <div class='spinner' *ngIf='waiting'>
      <ion-spinner class='waiting' name='circles'></ion-spinner>
    </div>
  </div>
</div>
